import React, { createContext, useContext, useMemo } from "react"
import { ExperimentTag } from "../experiments"

export type ActiveExperimentTags = ExperimentTag[]

const ActiveExperimentTagsContext = createContext<ActiveExperimentTags | undefined>(undefined)

type ActiveExperimentTagsProviderProps = React.ComponentProps<(typeof ActiveExperimentTagsContext)["Provider"]>
export const ActiveExperimentTagsProvider: React.FC<ActiveExperimentTagsProviderProps> = ({ value, children }) => {
    const stableValue = useMemo(() => value || [], [value])

    return <ActiveExperimentTagsContext.Provider value={stableValue}>{children}</ActiveExperimentTagsContext.Provider>
}

export const useActiveExperimentTags = () => {
    return useContext(ActiveExperimentTagsContext)
}
